import React, { useRef, useState } from 'react'
import styles from './return.module.css'
import { useTranslation } from 'react-i18next'
import { Button, message, Space } from 'antd'
import { postReturn, postReturnPhoto } from '../../../api/shippingApi'
import { showApiError, showMessage } from '../../../common/message'
import { EReturnReason, TRequestReturnOrder } from '../tracking/type'
import OrderInfo from '../../organism/return/OrderInfo'
import { ReturnReason } from '../../organism/return/ReturnReason'
import ShippingPhoto from '../../molecules/photo/ShippingPhoto'
import { useNavigate, useParams } from 'react-router-dom'
import { useDeliveryInfo } from '../../../api/useDeliveryInfo'
import { AxiosResponse } from 'axios'

export const ReturnRequestScreen = () => {
  const { t } = useTranslation(['return'])
  const { tracking } = useParams()
  const { deliveryInfo } = useDeliveryInfo(tracking)
  const navigate = useNavigate()
  const [messageApi, messageHolder] = message.useMessage()
  const reasonRef = useRef<EReturnReason>(EReturnReason.QUALITY)
  const detailRef = useRef('')
  const photoRef = useRef<File>()
  const ordersRef = useRef<TRequestReturnOrder[]>()
  const [isLoading, setLoading] = useState(false)

  const handleComplete = (res: AxiosResponse) => {
    console.log('res', res)
    showMessage(messageApi, t('Return application has been completed.'), 'success')
    setLoading(false)
    setTimeout(() => navigate(`/tracking/${res.data.tracking_number}/return`), 1000)
  }
  const handleSaveResult = () => {
    if (!isLoading) {
      if (!detailRef.current) {
        showMessage(messageApi, t('Please enter details.'))
      } else if (!ordersRef.current || ordersRef.current?.length <= 0) {
        showMessage(messageApi, t('Please select items.'))
      } else if (tracking) {
        setLoading(true)
        postReturn(tracking, {
          order_items: ordersRef.current,
          return_reason: reasonRef.current,
          return_memo: detailRef.current,
          process_return: true,
        })
          .then(res => {
            console.log('postReturn', res)
            if (photoRef.current) {
              postReturnPhoto(tracking, photoRef.current)
                .then(handleComplete)
                .catch(error => showApiError(error, messageApi))
                .finally(() => {
                  setLoading(false)
                })
            } else {
              handleComplete(res)
              setLoading(false)
            }
          })
          .catch(error => {
            console.log('res error', error.response)
            showApiError(error, messageApi)
            setLoading(false)
          })
      }
    }
  }

  return (
    <Space direction={'vertical'} size={20}>
      {messageHolder}
      <OrderInfo info={deliveryInfo} tracking_number={tracking} onUpdated={orders => (ordersRef.current = orders)} />
      <ReturnReason
        defaultReason={reasonRef.current}
        onChangeReason={reason => (reasonRef.current = reason)}
        onChangeDetail={detail => (detailRef.current = detail)}
      />
      <div className={'column'}>
        <div className={'group-title'}>{t('Return photo')}</div>
        <ShippingPhoto className={'round-cntr ' + styles.photo} onSelect={photo => (photoRef.current = photo)} />
      </div>
      <Button size={'large'} type={'primary'} block loading={isLoading} onClick={handleSaveResult}>
        {t('Request to return')}
      </Button>
    </Space>
  )
}
